<template>
	<div>
		<v-card-title class="mt-4">
			<h2>Moje opinie końcowe</h2>
		</v-card-title>
		<agency-project-final-evaluation-table/>
	</div>
</template>

<script>
	import AgencyProjectFinalEvaluationTable from "../final/AgencyProjectFinalEvaluationTable";

	export default {
		name: "AgencyProjectFinalEvaluationList",
		components: {AgencyProjectFinalEvaluationTable}
	};
</script>

<style scoped>

</style>